const KEY = "ssc:deviceId";

// Stable per-browser id; scopes guest sessions to this device on the API.
export function getDeviceId() {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || `dev_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(KEY, id);
  }
  return id;
}
